const ProductSearchCloseIcon = ({ width = 32, height = 32, ...props }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z"
        fill="white"
      />
      <path
        d="M10.343 9.08667L9.08594 10.3438L14.1143 15.3721L15.3713 15.3721L15.3713 14.115L10.343 9.08667Z"
        fill="black"
      />
      <path
        d="M9.08667 21.657L10.3438 22.9141L15.3721 17.8857L15.3721 16.6287L14.115 16.6287L9.08667 21.657Z"
        fill="black"
      />
      <path
        d="M22.9133 21.657L21.6562 22.9141L16.6279 17.8857L16.6279 16.6287L17.885 16.6287L22.9133 21.657Z"
        fill="black"
      />
      <path
        d="M22.9133 10.343L21.6562 9.08594L16.6279 14.1143L16.6279 15.3713L17.885 15.3713L22.9133 10.343Z"
        fill="black"
      />
    </svg>
  )
}

export default ProductSearchCloseIcon
